import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react';

export interface FingerprintData {
  visitorId: string;
  requestId: string;
  confidence: number;
  incognito?: boolean;
  botDetected?: boolean;
}

export function useFingerprintData(): FingerprintData | null {
  try {
    const { data, isLoading, error } = useVisitorData(
      { extendedResult: true },
      { immediate: true }
    );

    if (isLoading || error || !data) {
      return null;
    }

    const botDetected = (data as any).bot?.probability > 0.5;

    return {
      visitorId: data.visitorId,
      requestId: data.requestId,
      confidence: data.confidence?.score || 0,
      incognito: data.incognito || false,
      botDetected: botDetected || false,
    };
  } catch {
    return null;
  }
}
